module.exports = __webpack_public_path__ + "static/images/d92125732b3b0ff3eca03bf213e18bdc.svg";